export const savedActions = (type, payload) => {
  return {
    type: type,
    payload,
  };
};
